import React from "react";
import "./index.scss";

export default function HeadingMD ({text}) {
    return <h3>{text}</h3>
}